<template>
  <div style="height:100%;background-color: #ececec;">
    <div class="title fzpsxihjw">
      <span style="color: #005db6;">产品</span>中心
      <div style="font-size: 1.5rem;font-weight: bold;color: #636363">Product Center</div>
    </div>

    <el-row style="margin-top: 2rem; line-height: 1.8">
      <el-col
          v-for="(item, index) in contentList"
          :key="index"
          :offset="index % 2 === 0 ? 2 : 0"
          :span="10"
          style="margin-right: 1.2rem"
      >
        <div class="content">
          <div>
            <div>{{ item.name }}</div>
            <div style="  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制最多 3 行 */
  overflow: hidden;">{{ item.desc }}</div>

            <el-button
                class="part3-button"
                @click="$emit('route_jump', { route: 'product_center' })"
            >
              查看详情
            </el-button>
          </div>
          <el-image
              :src="item.img_url"
              fit="cover"
              style="width: 40%"
          />
        </div>
      </el-col>
    </el-row>

  </div>

</template>

<script setup>

import {ref} from "vue";
import {getIndexProduct} from "@/utils/utils";
const indexPicturePart2 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/product/xiechilun.png"
const contentList = ref([
  {
    name: '斜齿轮',
    desc: '斜齿轮具有传动平稳、啮合性能好、重合度高、齿轮强度高、静音、振动小等优点',
    route: 'product_center',
    img_url: indexPicturePart2
  },
  {
    name: '斜齿轮',
    desc: '斜齿轮具有传动平稳、啮合性能好、重合度高、齿轮强度高、静音、振动小等优点',
    route: 'product_center',
    img_url: indexPicturePart2
  },
  {
    name: '斜齿轮',
    desc: '斜齿轮具有传动平稳、啮合性能好、重合度高、齿轮强度高、静音、振动小等优点',
    route: 'product_center',
    img_url: indexPicturePart2
  },
  {
    name: '斜齿轮',
    desc: '斜齿轮具有传动平稳、啮合性能好、重合度高、齿轮强度高、静音、振动小等优点',
    route: 'product_center',
    img_url: indexPicturePart2
  }
]);

contentList.value = getIndexProduct()


</script>

<style scoped>
.title {
  font-size: 3rem;
  padding-top: 6rem;
  font-weight: bold;
}

.content {
  background-color: white;
  height: 8rem;
  margin-top: 0.8rem;
  display: flex;
  min-height: 16rem;

}

.content > div:nth-of-type(1) {
  padding: 2rem 2rem 0 2rem;
  text-align: left;
  flex: 1;
}

.content > div:nth-of-type(1) > div:nth-of-type(1) {
  font-size: 1.2rem;
  margin-bottom: 0.8rem;
}

.content > div:nth-of-type(1) > div:nth-of-type(2) {
  font-family: puHuiTi-Light sans-serif;
  margin-bottom: 1rem;
}

.part3-button {
  border: 1px black solid;
  border-radius: 2rem;
  width: 10rem;
  margin-top: 1.2rem;
}

.part3-button:hover {
  background-color: #003795;
  color: white;
}
</style>